var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.5568V5.5C18 4.94772 17.5523 4.5 17 4.5H7C6.44772 4.5 6 4.94772 6 5.5V19.5568L11.4188 15.6863C11.7665 15.4379 12.2335 15.4379 12.5812 15.6863L18 19.5568ZM12 17.7289L5.58124 22.3137C4.91937 22.7865 4 22.3134 4 21.5V5.5C4 3.84315 5.34315 2.5 7 2.5H17C18.6569 2.5 20 3.84315 20 5.5V21.5C20 22.3134 19.0806 22.7865 18.4188 22.3137L12 17.7289Z",
    fill: "#FFFFFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5125_13331",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 2,
    width: 16,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19.5568V5.5C18 4.94772 17.5523 4.5 17 4.5H7C6.44772 4.5 6 4.94772 6 5.5V19.5568L11.4188 15.6863C11.7665 15.4379 12.2335 15.4379 12.5812 15.6863L18 19.5568ZM12 17.7289L5.58124 22.3137C4.91937 22.7865 4 22.3134 4 21.5V5.5C4 3.84315 5.34315 2.5 7 2.5H17C18.6569 2.5 20 3.84315 20 5.5V21.5C20 22.3134 19.0806 22.7865 18.4188 22.3137L12 17.7289Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5125_13331)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.14e64bf6439411b771497065cea6c219.svg";
export { ForwardRef as ReactComponent };